// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logo[data-v-4ef0a45b] {\n  border: 1px solid #e9e9e9;\n  border-radius: 2px;\n  object-fit: cover;\n  object-position: center;\n}\n", ""]);
// Exports
module.exports = exports;
